import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { _ } from 'underscore';
import { IMyDpOptions, IMyDate, MyDatePicker } from 'mydatepicker';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq10',
  templateUrl: './cq10.component.html',
  styleUrls: [
    './cq10.component.css',
    '../commercial-questionnaire.component.css',
  ],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class Cq10Component implements OnInit {
  @Input() data: any;
  @ViewChild('mydp', { static: true }) mydp: MyDatePicker;
  in_contract;
  date;
  hgContract;
  user_bot = false;
  showbutton = true;
  ans_in_contract;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  index;
  showPicker = false;
  deviceWidth;
  isChecked = false;
  model: any;
  myDatePickerOptions: IMyDpOptions;
  contractDate;
  elem1;
  elem2;
  timer;
  location_expires = [];
  showTip = true;
  showTyping = false;
  time = 3000;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.hgContract = {
      value1: false,
      value2: false,
    };
    this.myDatePickerOptions = {
      // other options...
      dateFormat: 'mm/dd/yyyy',
      firstDayOfWeek: 'su',
      disableUntil: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate() - 1,
      },
      editableDateField: false,
      showClearDateBtn: false,
      showInputField: false,
      openSelectorOnInputClick: true,
      openSelectorTopOfInput : false
    };
  
    if(this.deviceWidth < 768)
    {
      this.myDatePickerOptions.openSelectorTopOfInput = true;
    }


  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('AlreadyExpired_mob');
      this.elem2 = document.getElementById('Expires_mob');
    } else {
      this.elem1 = document.getElementById('AlreadyExpired');
      this.elem2 = document.getElementById('Expires');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        com_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.location_expires = obj.fieldValue;
        if (
          !this.commercialService.addAddress &&
          !_.isEmpty(this.location_expires)
        ) {
          let index;
          if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          } else if (this.commercialService.serialNumber === null) {
            index = this.location_expires.length - 1;
          }
          if (!_.isEmpty(this.location_expires[index])) {
            this.in_contract = this.location_expires[index].value;
            this.isChecked = true;
            if (this.in_contract === 'No, already expired') {
              this.hgContract = {
                value1: true,
                value2: false,
              };
              this.elem1.parentElement.classList.add('active-select');
              this.ans_in_contract = this.in_contract;
              this.user_bot = true;
              if (this.deviceWidth < 768) {
                if (this.commercialService.modifyAddress) {
                  this.typingNext();
                } else {
                  this.goNext();
                }
              }
            } else if (this.in_contract.value === 'Expires on') {
              this.hgContract = {
                value1: false,
                value2: true,
              };
              this.elem2.parentElement.classList.add('active-select');
              if (typeof this.in_contract.date === 'string') {
                this.date = JSON.parse(this.in_contract.date);
              } else {
                this.date = this.in_contract.date;
              }
              if (this.date) {
                if (typeof this.date === 'string') {
                  this.date = new Date(this.date);
                }
                this.model = {
                  date: {
                    year: this.date.getFullYear(),
                    month: this.date.getMonth() + 1,
                    day: this.date.getDate(),
                  },
                };
                this.contractDate =
                  this.pad(this.model.date.month) +
                  '/' +
                  this.model.date.day +
                  '/' +
                  this.model.date.year;
                this.ans_in_contract =
                  this.in_contract.value + ' ' + this.contractDate;
                this.user_bot = true;
                this.showPicker = true;
                if (this.deviceWidth < 768) {
                  if (this.commercialService.modifyAddress) {
                    this.typingNext();
                  } else {
                    this.goNext();
                  }
                }
              }
            }
          }
        }
      }
    }

    if(!this.hgContract.value1 && !this.hgContract.value2)
    {
      this.showbutton = false;
    }
  }

  getIncontract(event) {
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
      if (event.target.value === 'No, already expired') {
        this.hgContract = {
          value1: true,
          value2: false,
        };
        this.elem1.parentElement.classList.add('active-select');
        if (_.contains(this.elem2.parentElement.classList, 'active-select')) {
          this.elem2.parentElement.classList.remove('active-select');
        }
        this.showPicker = false;
        this.date = '';
        this.ans_in_contract = event.target.value;
        this.user_bot = true;
      } else {
        this.hgContract = {
          value1: false,
          value2: true,
        };
        this.elem2.parentElement.classList.add('active-select');
        if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
          this.elem1.parentElement.classList.remove('active-select');
        }
      }
      if (event.target.value === 'Expires on') {
        this.showPicker = true;
        if (this.date === undefined || this.date === null) {
          this.in_contract = { value: event.target.value, date: '' };
          this.isChecked = false;
        } else {
          this.in_contract = { value: event.target.value, date: this.date };
        }
        if (_.isEmpty(this.model)) {
          this.user_bot = false;
        } else {
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      } else {
        this.in_contract = event.target.value;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
      this.hgContract = {
        value1: false,
        value2: false,
      };
      this.in_contract = '';
      this.showPicker = false;
      this.user_bot = false;
      this.elem1.parentElement.classList.remove('active-select');
      this.elem2.parentElement.classList.remove('active-select');
    }
    this.save();

    
    if (this.deviceWidth < 768) {}else
    {
      if(event.target.value === "No, already expired")
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
     

    }
  }

  getDate() {
    if (!this.hgContract.value2) {
      this.hgContract = {
        value1: false,
        value2: true,
      };
      this.isChecked = true;
    }
    this.elem2.parentElement.classList.add('active-select');
    if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
      this.elem1.parentElement.classList.remove('active-select');
    }
    this.date = new Date(this.model.formatted);
    this.contractDate =
      this.pad(this.model.date.month) +
      '/' +
      this.model.date.day +
      '/' +
      this.model.date.year;
    this.in_contract = { value: 'Expires on', date: JSON.stringify(this.date) };
    this.ans_in_contract = this.in_contract.value + ' ' + this.contractDate;
    this.save();
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if(!this.showbutton)
      {
        this.next();
      }
    }

    

  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  next() {
    if (_.isEmpty(this.in_contract)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
    } else if (this.in_contract.value === 'Expires on') {
      if (_.isEmpty(this.model)) {
      } else {
        this.ans_in_contract = this.in_contract.value + ' ' + this.contractDate;
        this.save();
        this.commercialService.messageService({ currentId: this.data });
      }
    } else if (this.in_contract === 'No, already expired') {
      this.commercialService.messageService({ currentId: this.data });
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  save() {
    let index;
    if (this.commercialService.serialNumber !== null) {
      index = this.commercialService.serialNumber;
    } else if (this.commercialService.serialNumber === null) {
      index = this.location_expires.length - 1;
    }
    this.location_expires[index] = {
      serialNo: index + 1,
      value: this.in_contract,
      date: this.in_contract.date,
    };
    const Obj = {
      com_question_id: this.data,
      fieldName: 'in_contract',
      fieldValue: this.location_expires,
    };
    this.commercialService.updateResponses(Obj);
  }
}
